<template lang="pug">
  ModalLayout(
    type="market"
    :active="isVisible"
    :wrapStyle="wrapStyle"
  )
    .market-popup(:style="bannerStyle")
      .market-popup__progress
        .market-popup__progress-bar
      img.market-popup__image(
        src="~@/assets/img/header/banner/market/popup.png"
        alt="Новинка! Спортивное питание от Gorilla"
      )
      //- Transparent click zones sit exactly over the Wildberries / OZON buttons baked into the image.
      a.market-popup__hotspot.market-popup__hotspot--wb(
        :href="wbUrl"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Купить на Wildberries"
      )
      a.market-popup__hotspot.market-popup__hotspot--ozon(
        :href="ozonUrl"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Купить на OZON"
      )
</template>

<script>
import modals from '@/mixins/modals'

// Native size of the cropped popup artwork (gray frame shaved off) — the stage is scaled to fit the viewport.
const W = 320
const H = 560

export default {
  name: 'ModalMarket',
  mixins: [modals],
  data: () => ({
    isVisible: true,
    timer: null,
    remainingTime: 3 * 1000,
    scale: 1,
    wbUrl: 'https://www.wildberries.ru/seller/250051432?sort=popular&page=1&fbrand=312295560',
    ozonUrl: 'https://www.ozon.ru/seller/fahrenheit-nutrition-formula/brand/gorilla-ultimate-102077913/'
  }),
  mounted () {
    this.startTimer()
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy () {
    clearTimeout(this.timer)
    window.removeEventListener('resize', this.updateScale)
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
  computed: {
    bannerStyle () {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: 'top left',
        width: `${W}px`,
        height: `${H}px`,
        position: 'absolute',
        top: 0,
        left: 0
      }
    },
    wrapStyle () {
      const s = this.scale
      return {
        width: `${W * s}px`,
        height: `${H * s}px`
      }
    }
  },
  methods: {
    updateScale () {
      // Fill the same footprint as the preloader banner it replaces (~84% height / 96% width).
      // No cap at 1 — the source PNG is exported at 3x, so upscaling stays crisp.
      this.scale = Math.min(window.innerWidth * 0.96 / W, window.innerHeight * 0.84 / H)
    },
    startTimer () {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => { this.isVisible = false }, this.remainingTime)
    },
    handleVisibilityChange () {
      this.startTimer()
    }
  }
}
</script>
